module.exports = __webpack_public_path__ + "static/media/UniNeueThin-Italic.c911fe79.woff";